module.exports = __webpack_public_path__ + "images/for_company_page/LP_header_sp_27972b417009e7787e84252ea00b8b55.jpg";